import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const ExtensionsSkeleton: React.FC = () => {
  return (
    <section id="extensions" className="content-section">
      <div className="flex flex-wrap justify-between items-center gap-4 mb-6 header-border pb-4">
        <h2 className="text-xl font-semibold text-white">extension catalog</h2>
        <div className="relative">
          <SkeletonLoader width="w-64" height="h-10" className="rounded" />
        </div>
      </div>
      
      <div id="extensions-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="paint-card">
            <div className="card-icon-placeholder">
              <SkeletonLoader width="w-16" height="h-16" className="rounded-lg mx-auto" />
            </div>
            <div className="card-content">
              <SkeletonLoader width="w-3/4" height="h-5" className="mb-2" />
              <div className="mb-3">
                <SkeletonLoader width="w-full" height="h-3" className="mb-1" />
                <SkeletonLoader width="w-5/6" height="h-3" />
              </div>
              <SkeletonLoader width="w-full" height="h-8" className="rounded" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExtensionsSkeleton;